import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeDescriptionCommand extends BaseCommand {
  CommandName = "ChangeDescription";
  Command: { Value: string };
  constructor(sessionId: string, operationId: string, value: string) {
    super(sessionId, operationId);
    this.Command = { Value: value };
  }
}
